import {useQueries} from 'react-query'
import {deleteStudent, fetchStudentList} from './api'
import {fetchAppConfig, triggerSync} from './api' // ✅ NEW
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import StudentForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import ModalWithForm from '../../../components/ModalWithForm'
import {Badge, Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import WithModal from '../../../components/WithModal'
import TripDetails from './TripDetails'
import {Helmet} from 'react-helmet'
import ViewAll from '../../../components/ViewAll'
import NFC from './NFC'
import clsx from 'clsx'
import {useState, useEffect} from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'
import CustomSelect from '../../../components/formikControl/advancedSelect/Custom'
import {fetchClassList} from '../class/api'
import {fetchDivisionList} from '../division/api'
import {KTIcon} from '../../../_metronic/helpers'
import LinkGuardianForm from './LinkGuardianForm'
import StudentUpload from '../student-upload/Index'
import NFCUpload from '../nfc-upload/Index'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import PortalDropdown from '../../../components/PortalDropdown'
import EditLabel from '../../../components/EditLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import DeleteLabel from '../../../components/DeleteLabel'
import MoreInfoLabel from '../../../components/MoreInfoLabel'
import StudentCreationForm from './CreateForm'
import {fetchSubSchoolDetails} from '../profile/api'
import {fetchShiftList} from '../shift/api'

const studentBreadcrumbs = [
  {title: 'User Management', path: 'users/student', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]

function Student() {
  const [filter, setFilter] = useState({studentClass: '', division: '', school: '', shift: ''})

  // ✅ Sync states
  const [syncEnabled, setSyncEnabled] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)

  // ✅ Load config
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetchAppConfig()
        if (res?.data?.sync_data === 1) {
          setSyncEnabled(true)
        }
      } catch (err) {
        console.error(err)
      }
    }
    loadConfig()
  }, [])

  // ✅ Sync handler
  const handleSyncData = async () => {
    if (!window.confirm('Are you sure you want to sync data?')) return

    const toastId = toast.loading('Syncing data...')

    try {
      setSyncLoading(true)
      const res = await triggerSync()
      toast.success(res?.message || 'Sync completed', {id: toastId})
    } catch (error) {
      toast.error(
      error?.response?.data?.message ||
      error?.message ||
      'Sync failed',
      {id: toastId})
    } finally {
      setSyncLoading(false)
    }
  }

    const calls = [
    {
      queryKey: ['studentList', filter],
      queryFn: () => fetchStudentList(filter),
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
    {
      queryKey: 'class',
      queryFn: fetchClassList,
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'division',
      queryFn: fetchDivisionList,
      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'subschools',
      queryFn: fetchSubSchoolDetails,
      refetchOnWindowFocus: false
    },
    {
      queryKey: 'shift', 
      queryFn: fetchShiftList,
      refetchOnWindowFocus: false
    },


  ]

  const results = useQueries(calls)

  const [
    {
      data: studentList,
      isError: isStudentError,
      refetch: refetchStudents,
      isLoading: isLoadingStudents,
      isFetching: isFetchingStudents,
    },
    {data: classList, isError: isClassError, isLoading: isLoadingClass},
    {data: divisionList, isError: isDivisionError, isLoading: isLoadingDivision},
    {data: subschoolList, isError: isSubSchoolError, isLoading: isLoadingsubschool},
    {data: shiftList, isError: isShiftError, isLoading: isLoadingshift},
  ] = results

  if (isLoadingStudents) return <Processing />

 const cellModifier = {
    student_status: ({value}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    dob: ({value}) => {
      if (value) {
        return new Date(value).toDateString()
      } else {
        return value
      }
    },
     more: ({row}) => {
      const orderedFields = [
        ...Object.entries(viewProps.Student.primaryFieldsToLabelMap),
        ...Object.entries(viewProps.Student.secondaryFieldsToMap),
      ]
      return (
        <WithModal
          renderModalBody={() => (
            <ViewAll data={row.original} cellModifier={cellModifier} fieldOrder={orderedFields} />
          )}
          modalTitle={
            <span>
              Details of <span className="text-primary">{row.original.student_name}</span>
            </span>
          }
          modalAttrs={{backdrop: true, size: 'lg'}}
        >
          <MoreInfoLabel />
        </WithModal>
      )
    },
    Actions: ({row}) => (
      <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
        <span className="dropdown-item p-0">
          <ModalWithForm modalTitle={`Trip Details of ${row.original.student_name}`} initialValues={row.original} onSubmit={refetchStudents} Form={TripDetails}>
            <div className="px-3 py-2">Trip Details</div>
          </ModalWithForm>
        </span>
        <span className="dropdown-item p-0">
          <ModalWithForm modalTitle={`Guardian Details`} initialValues={row.original} Form={LinkGuardianForm}>
            <div className="px-3 py-2">Guardians</div>
          </ModalWithForm>
        </span>
        <span className="dropdown-item p-0">
          <ModalWithForm modalTitle={`RFID`} initialValues={row.original} Form={NFC} onSubmit={refetchStudents}>
            <div className="px-3 py-2">RFID</div>
          </ModalWithForm>
        </span>
        <span className="dropdown-item p-0">
          <ModalWithForm modalTitle={'Update Student'} initialValues={row.original} onSubmit={refetchStudents} Form={StudentForm}>
            <EditLabel />
          </ModalWithForm>
        </span>
        <span className="dropdown-item p-0">
          <DeleteConfirmationModal
            onDelete={async () => {
              const t = toast.loading('Deleting...')
              try {
                await deleteStudent(row.original.student_id)
                await refetchStudents()
                toast.success('Deleted', {id: t})
              } catch {
                toast.error('Error', {id: t})
              }
            }}
          >
            <DeleteLabel />
          </DeleteConfirmationModal>
        </span>
      </PortalDropdown>
    ),
  }

  return (
    <>
      <Helmet><title>TrackNAB | Students</title></Helmet>
      <PageTitle breadcrumbs={studentBreadcrumbs}>Student</PageTitle>

      {isStudentError ? <Error500 /> : (
        <CRUDTable
          data={studentList?.data || []}
          {...viewProps.Student}
          fieldToLabelMap={viewProps.Student.primaryFieldsToLabelMap}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['More Info', 'Actions']}
          headerExtras={
            <div className="d-flex align-items-center flex-column gap-3 w-100">

              {/* BUTTON ROW */}
              <div className="d-flex gap-4 align-items-center flex-wrap">
                <ModalWithForm modalTitle={'Add Student'} onSubmit={refetchStudents} Form={StudentCreationForm}>
                  <Button size="sm">Add Student</Button>
                </ModalWithForm>

                <ModalWithForm modalTitle={'Student Upload'} onSubmit={refetchStudents} Form={StudentUpload}>
                  <Button size="sm">Upload</Button>
                </ModalWithForm>

                <ModalWithForm modalTitle={'NFC Upload'} onSubmit={refetchStudents} Form={NFCUpload}>
                  <Button size="sm">NFC Upload</Button>
                </ModalWithForm>

                {syncEnabled && (
                  <Button size="sm" variant="success" onClick={handleSyncData}>
                    {syncLoading ? 'Syncing...' : 'Sync Data'}
                  </Button>
                )}
              </div>

              {/* FILTER ROW */}
              <div className="d-flex align-items-center gap-2 flex-wrap">     
    <CustomSelect
        placeholder="Shift"
        size="xs"
        onChange={(selected) =>
          setFilter({...filter, shift: selected?.shift_id || ''})
        }
        options={shiftList?.data || []}
        optionLabel="shift_name"
        optionValue="shift_id"
        isLoading={isLoadingshift}
        className="w-auto"
      />
      <CustomSelect
        placeholder="Sub School"
        size="xs"
        onChange={(selected) =>
          setFilter({...filter, school: selected?.sub_school_id || ''})
        }
        options={subschoolList?.data || []}
        optionLabel="sub_school_name"
        optionValue="sub_school_id"
        isLoading={isLoadingsubschool}
        className="w-auto"
      />

      <CustomSelect
        placeholder="Class"
        size="xs"
        onChange={(selected) =>
          setFilter({...filter, studentClass: selected?.class_name || ''})
        }
        options={classList?.data || []}
        optionLabel="class_name"
        optionValue="class_name"
        isLoading={isLoadingClass}
        className="w-auto"
      />

      <CustomSelect
        placeholder="Division"
        size="xs"
        onChange={(selected) =>
          setFilter({...filter, division: selected?.division_name || ''})
        }
        options={divisionList?.data || []}
        optionLabel="division_name"
        optionValue="division_name"
        isLoading={isLoadingDivision}
        className="w-auto"
      />
                <Badge bg="light"><KTIcon iconName="filter" /></Badge>
              </div>

            </div>
          }
        />
      )}

      {isFetchingStudents && <TopBarProgress />}
      <Toaster />
    </>
  )
}

export default Student